import ContentLoader from 'stimulus-content-loader'
import {startIcons} from '../import_lucid.js'

export default class extends ContentLoader {

  static values = {
    url: String,
    lazyLoading: Boolean,
    lazyLoadingThreshold: Number,
    lazyLoadingRootMargin: {
      type: String,
      default: '0px'
    },
    refreshInterval: Number,
    loadScripts: Boolean,
    replaceHtml: {
      type: Boolean,
      default: false
    },
    debounceTime: Number
  }

  fetch() {
    if (!this.urlValue) return;

    if (this.hasDebounceTimeValue && this.debounceTimeValue > 0) {
      this.debouncedFetch = this.debounce(() => {
        this.performFetch();
      }, this.debounceTimeValue);
      this.debouncedFetch();
    } else {
      this.performFetch();
    }
  }

  performFetch() {
    fetch(this.urlValue)
        .then((response) => response.text())
        .then((html) => {
          if (this.replaceHtmlValue) {
            this.element.outerHTML = html;
          } else {
            this.element.innerHTML = html;
          }
          if (this.loadScriptsValue) {
            this.loadScripts();
          }
          startIcons()
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    this.urlValue = undefined;
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
}

